import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  fetchBlogDetails,
  fetchBlogpage,
  fetchServices,
  fetchTestimonials,
} from "../Redux/slice/homeSlice";
import { Icon } from "@iconify/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const TestimonyRap = styled.div`
  background: linear-gradient(0deg, #ffffff 0%, #f6f5f2 20%);
  padding-bottom: 50px;
  .upper-p {
    padding: 5px 15px;
    width: fit-content;
    height: 31px;
    display: flex;
    border: 1px solid #0000001a;
    color: #1c4b42;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }
  h1 {
    color: #1c4b42;
    font-size: 52px;
    line-height: 57px;
    font-weight: 400;
    max-width: 700px;
  }
  h2 {
    color: #1c4b42;
    font-size: 48px;
    line-height: 57px;
    font-weight: 400;
  }
  .test-1 p {
color: #1C4B42;
max-width: 555px;
font-weight: 400;
font-size: 20px;
line-height:30px;
    
  }
  .test-1 {
    display: flex;
    padding-top: 160px;
    flex-direction: column;
    gap: 20px;
  }
  .test-2 img {
    width: 87px;
    height: 40px;
} 
.test-2 {
    padding-top: 50px;
    padding-bottom: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-top: 80px;
    flex-wrap: wrap;
    border-top: 1px solid #0000001A;
}
.card0-3-upper img {
    width: 45px;
    height: 45px;
  }
  .card0-3-upper p {
    color: #000000cc;
    font-size: 20px;
    line-height: 30px;
    max-width: 518px;
    font-weight: 400;
    margin-left: 45px;
  }
  .card0-3-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card0-3-down-left img {
    width: 54px;
    height: 54px;
    border-radius: 100px;
  }
  .card0-3-down-left h4 {
    color: #1c4b42;
    font-size: 15px;
    font-weight: 500;
  }
  .card0-3-down-left p {
    color: #7E7E7E;
    font-size: 11px;
    font-weight: 500;

  }
    .card0-3-down-left {
        display: flex;
align-items: center;
        gap: 10px;
    }
    .card0-3-down-inner {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }
    .card0-3-circle {
        border-radius: 100px;
        width: 52px;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
    }
    .card0-3-down-right {
        display: flex;
        gap: 15px;
    }
    .card0-3-down {
        display: flex;
        justify-content: space-between;
    }
    .test-3-card {
        background: #dededbff;
        width: 590px;
        overflow: hidden;
        height: 400px;
        border-radius: 24px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding: 20px;
    }
.test-3 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}
.test-3-upper h2 {
    max-width: 546px;
    text-align: center;
}
.test-3-upper {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 20px;
}
.all-test-3 {
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    gap: 50px;
}


  .test-4-left {
    position: relative;
  }
  .test-4-box {
    backdrop-filter: blur(40px);
    background: #ffffffcc;
    border-radius: 20px;
    width: 170px;
    height: 115px;
    display: flex;
    position: absolute;
    right: 20px;
    bottom: 20px;
    justify-content: center;
    align-items: center;
  }
  .test-4-box img {
    width: 100px;
    height: 45px;
  }
  .card-4-upper h6 {
    border: 1px solid #0000001a;
    width: 143px;
    height: 31px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1c4b42;
    font-size: 11px;
    font-weight: 500;
  }
  .card-4-upper h3 {
    max-width: 306px;
    line-height: 36px;
    font-size: 30px;
    color: #1c4b42;
    font-weight: 500;
  }
  .card-4-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .upper-4-icon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }
  .upper-4-icon img {
    width: 20px;
    height: 20px;
  }
  .card-4-down p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 356px;
    line-height: 22px;
  }
  .card-4-down {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card-4-btn, .-btn {
    border: none;
    background: #1c4b42;
    color: #ffffff;
    width: 175px;
    border-radius: 100px;
    height: 48px;
    font-size: 15px;
    font-weight: 400;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-4-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    background: #1c4b42;
    border-radius: 100px;
  }
  .card-4-sub {
    display: flex;
  }
  .test-4-card {
    background: #b4e717;
    width: 420px;
    height: 520px;
    border-radius: 24px;
    display: flex;
    padding: 20px;
    flex-direction: column;
    justify-content: space-between;
  }
  .test-4-img {
    max-width: 750px;
    height: 520px;
        border-radius: 24px;

  }
  .test-4 {
    display: flex;
    gap: 20px;
    margin-top: 80px;
    justify-content: space-between;
  }
   @media (max-width: 1270px) {
.test-3-card {
        width: 520px;
   }
   .test-4-img {
    max-width: 700px;
   }
}

   @media (max-width: 1200px) {

   .test-4-img {
    max-width: 650px;
   }
}
   @media (max-width: 1100px) {
.test-3-card {
        width: 450px;
   }

     .test-4-img {
    max-width: 550px;
   }
}
 @media (max-width: 992px) { 
h1 {
    font-size: 45px;
}
h2 {
    font-size: 40px;
}
.contact-2 {
  flex-wrap: wrap;
}
.test-4 {
    flex-direction: column;
}
  .test-4-img {
    max-width: 100%;
    height: auto;
   }
.test-3-card, .test-4-card {
        width: 100%;
   }
   .test-3 {
    grid-template-columns: repeat(1, 1fr);
   }
 }
  @media (max-width: 700px) {  
    h1 {
    font-size: 32px;
    line-height: 40px;
}
h2 {
    font-size: 28px;
    line-height: 28px;
}
  }
  @media (max-width: 600px) { 
.test-4-card {
     height: 450px;
}
  }
  @media (max-width: 500px) { 
h1, .test-1 p  {
    text-align: center;
}


.test-1 {
    align-items: center;
}
 }
`;

const Testimonials = () => {
 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { testimonialObject } = useSelector((state) => state.content);
  console.log(testimonialObject);


const topInfo = testimonialObject?.data?.topInfo;
const partners = testimonialObject?.data?.partners;
const testimonials = testimonialObject?.data?.testimonial?.lists;
const bottomBanner = testimonialObject?.data?.bottomBanner;

  useEffect(() => {
    dispatch(fetchTestimonials());
  }, [dispatch]);

   const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);


  return (
    <TestimonyRap>
     <div className="test-1 containers">
        <h6 className="upper-p">{topInfo?.small_title}</h6>
        <h1>
            {topInfo?.main_title?.split(" ").map((word, index) => {
              const targetIndexes = [1, 1]; // 2nd word (index 1), 3rd word (index 2)
              return targetIndexes.includes(index) ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              );
            })}
     </h1>
        <p>{topInfo?.content}</p>
     </div>
     <div className="containers">
        <div className="test-2">
            {partners?.map((item) => (
                 <img src={`https://backoffice.holybrookstransportation.com/${item?.image}`} alt="" />
            ))}
           
        </div>
    </div>
    <div className="all-test-3 containers">
        <div className="test-3-upper">
            <h6 className="upper-p">{testimonialObject?.data?.testimonial?.heading?.small_title}</h6>
            <h2>
                {testimonialObject?.data?.testimonial?.heading?.main_title?.split(" ").map((word, index) => {
              const targetIndexes = [1, 1]; // 2nd word (index 1), 3rd word (index 2)
              return targetIndexes.includes(index) ? (
                <span key={index} style={{ color: "#b4e717" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              );
            })}
              </h2>
        </div>
        <div className="test-3">
            
            {testimonials?.map((item) => (
                <div className="test-3-card ">
                        <div className="card0-3-upper">
                        <img src="/images/icon-1.png" alt="" />
                        <p>{item?.testimony}</p>
                        </div>
                        <div className="card0-3-down">
                        <div className="card0-3-down-left">
                            <img
                            src={`https://backoffice.holybrookstransportation.com/${item?.image}`}
                            alt=""
                            />
                            <div className={`card0-3-down-inner`}>
                            <h4>{item?.full_name}</h4>
                            <p>{item?.title}</p>
                            </div>
                        </div>
                        
                        </div>
                    </div>
            ))}
        </div>
    </div>
     <div className="test-4 containers ">
              <div className="test-4-left">
                <img
                  className="test-4-img"
                  src={`https://backoffice.holybrookstransportation.com/${bottomBanner?.banner}`}
                  alt=""
                />
               
              </div>
              <div className="test-4-card">
                <div className="card-4-upper">
                    <div className="upper-4-icon">
                  <h6>{bottomBanner?.small_title}</h6>
                  <img src="/images/icon-5.png" alt="" />
                  </div>
                  <h3>{bottomBanner?.main_title}</h3>
                </div>
                <div className="card-4-down">
                  <p>{bottomBanner?.content}</p>
                  <div className="card-4-sub">
                    <a
                      href={bottomBanner?.first_btn_link}
                      className="card-4-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {bottomBanner?.first_btn_title}
                    </a>
                    <div className="card-4-circle">
                         <Icon
                                width="14px"
                                height="14px"
                                icon="mdi:arrow-top-right"
                                style={{ color: " #b4e717" }}
                            />
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </TestimonyRap>
  );
};

export default Testimonials;
